import React from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useNavigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import {
  TabViewValues,
  Languages,
} from "../../ReusableComponents/CommonFunctions";
import { useSelector, useDispatch } from "react-redux";
import { SelectLanguageData } from "../../Redux/Reducers/Common/Language";
const OverallDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const Tabs = [
    { Name: "Scenario based Questions", Value: "SCQ" },
    { Name: "Direct Questions", Value: "DQ" },
    { Name: "Input based Questions", Value: "INQ" },
  ];

  const ChangeTab = (e) => {
    if (location.pathname.includes("/OverallDashboard")) {
      navigate(`/QBAdmin/OverallDashboard`, { state: { Tab: e } });
    } else if (location.pathname.includes("/ReviewQuestions")) {
      navigate(`/QBAdmin/ReviewQuestions`, { state: { Tab: e } });
    }
  };

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />

        <div className=" alignitems">
          <div className="dflex alignitems gap-2" style={{ position: "absolute", left: "80vw" }} >
            {!location.pathname.includes("/TranslateQuestion") &&
              !location.pathname.includes("/AddUpdateQuestions") &&
              !location.pathname.includes("/TranslateScenario") &&
              !location.pathname.includes("/ScenarioQuestions") &&
              !location.pathname.includes("/AddEditScenario") &&
              location.pathname.includes("/OverallDashboard") &&
              !location.pathname.includes("/VerificationSTatus") &&
              ![3,4,5].includes(parseInt(items?.subjectId)) && (
                <>
                  <span className="DropdownHeader">Select Language : </span>{" "}
                  <Languages onChange={(e) => { dispatch(SelectLanguageData({ SLanguage: e })); }} />
                </>
              )}
          </div>
          <TabViewValues Tabs={Tabs} Selectedtab={location.state?.Tab} onClick={(e) => { ChangeTab(e); }} />
        </div>
        <Outlet />
      </div>
    </>
  );
};
export default OverallDashboard;
